export default {
      id: "i-lk-nav-rt-red-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/sprite.svg#i-lk-nav-rt-red",
      toString: function () {
        return this.url;
      }
    }